import React, { useState } from 'react';
import styles from './BookItem.module.scss';
import Text from '../../atoms/text/Text';
import Modal from '../../hoc/modal/Modal';
import defaultImage from '../../../assets/images/defaultNews.png';
import imageNotFound from '../../../assets/images/defaultNews.png';
import moment from 'moment';
import InnerButton from '../../atoms/innerButton/innerButton';
const closeSvg = '/icons/close.svg';
import DOMPurify from 'dompurify';
import useIsRtl from '../../../app/helpers/isRtl';
import { useNavigate } from 'react-router-dom';
const lineSvg = '/assets/svg/line.svg';

const BookItem = ({ cardImageClass, book, redirectType }) => {
  const navigate = useNavigate();
  const isRtl = useIsRtl();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const cardImageClasses = `${styles['card-image']} ${styles[cardImageClass]}`;
  const magazineUrl = DOMPurify.sanitize(`${book.url}${book.magazineBlob}`);

  const handleClick = () => {
    // setIsModalOpen(true);
    let type = '';
    if (redirectType === 1) {
      type = 'magazine';
    } else if (redirectType === 2) {
      type = 'security';
    } else {
      type = 'policies';
    }
    navigate(`/academy-eco-magazine/${type}-${book.magazineId}`);
  };

  const handleViewClick = () => {
    window.open(
      `/pdf-view?pdfUrl=${encodeURIComponent(magazineUrl)}`,
      '_blank'
    );
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDownloadClick = () => {
    setIsDownloading(true);
    //is was sanitized here
    const sanitizedUrl = DOMPurify.sanitize(magazineUrl, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
    });

    try {
      new URL(sanitizedUrl);
    } catch (error) {
      console.warn('Invalid URL:', sanitizedUrl);
      return;
    }

    fetch(sanitizedUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = DOMPurify.sanitize(url);
        link.download = `${'Dubai-Police-Academy'}-${book.magazineBlob}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setIsDownloading(false);
      })
      .catch((error) => {
        setIsDownloading(false);
        console.error('Error downloading the PDF:', error);
      });
  };

  return (
    <>
      <div className={styles['card-container']} onClick={handleClick}>
        <div className={cardImageClasses}>
          <div className={styles.backBook1}></div>
          <div className={styles.backBook}></div>
          <div className={styles.layer1}></div>
          <div className={styles.layer2}></div>
          <div className={cardImageClasses}>
            <img
              src={
                DOMPurify.sanitize(`${book.url + book.magazineThumbnail}`) ||
                imageNotFound
              }
              className={styles.dpfImage}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = imageNotFound;
              }}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        <div className={styles['card']}>
          <div className={styles['info']}>
            <Text
              title={moment(book?.magazineDate).format('MMMM-YYYY')}
              variant="text-regular-18-green"
              style={{ cursor: 'pointer' }}
              className={styles['title']}
            />
            <Text
              title={book?.title_AR}
              variant="text-regular-16-black"
              style={{ cursor: 'pointer', opacity: 0.7 }}
              className={`title-ar ${styles['text']}`}
            />
          </div>
        </div>{' '}
        <div className={`${styles['line-container']}`}>
          <img src={lineSvg} className={styles.line} />
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        modalBodyClassname={styles.modalBody}
        dialogClassName={styles.dialogClassName}
      >
        <img
          src={closeSvg}
          className={styles.close}
          onClick={handleCloseModal}
        />
        <img
          src={DOMPurify.sanitize(
            `${book.url + book.magazineThumbnail}` ?? defaultImage
          )}
          className={styles.modalImage}
        />
        <div className={styles['pdf-info-container']}>
          <div className={`${styles.pdfInfo} ${isRtl ? 'rtl' : ''}`}>
            <div className={styles.infoItems}>
              <Text
                title="guideline.dateOfPublication"
                variant="text-bold-italic-16-black"
                className={styles['infoText']}
              />
              <span> : </span>
              <Text
                title={`${moment(book?.magazineDate)
                  .format('MM/DD/YY')
                  .toUpperCase()}`}
                variant="text-regular-16-black"
                className={`${styles['infodesc']} ${
                  isRtl ? styles.infoRtl : ''
                }`}
              />
            </div>
            <div className={styles.infoItems}>
              <Text
                title="guideline.edition"
                variant="text-bold-italic-16-black"
                className={styles['infoText']}
              />
              <span> : </span>
              <Text
                title={`${book.editionNumber ?? 'N/A'}`}
                variant="text-regular-16-black"
                className={`${styles['infodesc']} ${
                  isRtl ? styles.infoRtl : ''
                }`}
              />
            </div>
            <div className={styles.infoItems}>
              <Text
                title={'guideline.numberOfPages'}
                variant="text-bold-italic-16-black"
                className={styles['infoText']}
              />
              <span> : </span>
              <Text
                title={`${book.pageNumber} ${isRtl ? 'صفحة' : 'Pages'}`}
                variant="text-regular-16-black"
                className={`${styles['infodesc']} ${
                  isRtl ? styles.infoRtl : ''
                }`}
              />
            </div>
          </div>
          <div className={styles.actions}>
            <Text
              title={'common.pdfVersion'}
              variant="text-bold-italic-16"
              className={styles['infoText']}
            />
            <div className={styles.actionbuttons}>
              <InnerButton
                title={'common.view'}
                style={{ width: '100%' }}
                onClick={handleViewClick}
              />
              <InnerButton
                title={'common.download'}
                style={{ width: '100%' }}
                onClick={handleDownloadClick}
                isLoading={isDownloading}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BookItem;
